export default __webpack_public_path__ + "static/Mask group-dc6b9a90188f747fb7d80cb0caa1fa05.jpg";